<template>
    <div class="home-header home-box">
			<div class="left">
				<img src="./../assets/img/cnLogo.png" alt="" />
			</div>
			<div class="left-title" v-if="$t('language.name')=='English'">
				<p class="one">{{ $t('navbar.info1') }}</p>
				<p class="tow">{{ $t('navbar.info2') }}</p>
			</div>
			<div class="header-r">
				<div class="language" @mouseover="languageShow=true" @mouseout="languageShow=false">
					<div class="country"></div>
					<div class="text">简体
						<ul v-show="languageShow">
							<li @click="changeLang('zh')"><span class="one"></span>简体中文</li>
							<li @click="changeLang('eh')"><span class="two"></span>English</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="right" v-if="$t('language.name')=='English'">
				<router-link to="login" :class="$route.name=='login'?'active':''">{{ $t('navbar.home') }}</router-link>
				<router-link to="introduction" :class="$route.name=='introduction'?'active':''">{{ $t('navbar.introduction') }}</router-link>
				<router-link to="cooperation" :class="$route.name=='cooperation'?'active':''">{{ $t('navbar.cooperation') }}</router-link>
				<router-link to="contact" :class="$route.name=='contact'?'active':''">{{ $t('navbar.contact') }}</router-link>
				<router-link to="about" :class="$route.name=='about'?'active':''">{{ $t('navbar.about') }}</router-link>
			</div>
			<div class="right" v-else>
				<router-link to="login" :class="$route.name=='login'?'active':''">{{ $t('navbar.home') }}</router-link>
				<router-link to="introduction" :class="$route.name=='introduction'?'active':''">{{ $t('navbar.introduction') }}</router-link>
				<router-link to="cooperation" :class="$route.name=='cooperation'?'active':''">{{ $t('navbar.cooperation') }}</router-link>
				<router-link to="contact" :class="$route.name=='contact'?'active':''">{{ $t('navbar.contact') }}</router-link>
				<router-link to="about" :class="$route.name=='about'?'active':''">{{ $t('navbar.about') }}</router-link>
			</div>
		</div>
</template>
<script>
    export default {
        name: 'FooterS',
		data(){
			return{
			    languageShow: false
			}
        },
        methods:{
			changeLang() {
				let locale = localStorage.getItem('language')||'zh';
				var temp=locale === 'zh' ?  'en' : 'zh';
				this.$i18n.locale=temp;
				localStorage.language=temp;
            },
        }
	}
</script>


// WEBPACK FOOTER //
// src/components/Footer-s.vue